import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';

export const Button = styled.button.attrs(props => ({
  // Remove custom props before passing to DOM
  variant: undefined,
  size: undefined,
  fullWidth: undefined,
}))`
  background-color: ${props => {
    if (props.variant === 'secondary') return colors.secondary;
    if (props.variant === 'danger') return colors.error;
    if (props.variant === 'success') return colors.success;
    return colors.primary;
  }};
  color: ${props => props.variant === 'secondary' ? colors.text : 'white'};
  padding: ${props => props.size === 'small' ? '8px 16px' : '12px 24px'};
  border-radius: 6px;
  font-size: ${props => props.size === 'small' ? '14px' : '16px'};
  font-weight: 500;
  transition: all 0.3s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px ${colors.shadow};
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

